<template>
  <div v-if="$apollo.loading">
    <spinner />
  </div>
  <div v-else class="registration-success-page-container">
    <div class="registration-success-page">
      <img class="info-image" src="../../../public/assets/high_five.svg" alt="high_five" />
      <span class="my-page-title">{{ $t('paymentSuccessful') }}</span>
      <span class="description">
        {{ $t('ticketReady') }}
      </span>
      <div id="buttons-container">
        <a
          v-if="user && order"
          target="_blank"
          class="main-button v-btn v-btn--depressed v-btn--round theme--light primary"
          :href="`${customerURL}/orders/${order.uuid}`"
        >
          {{ $t('viewTheOrder') }}
        </a>
        <a
          id="download-ticket"
          :class="{ 'v-btn--disabled': !ticketDownloaded }"
          class="main-button v-btn v-btn--depressed v-btn--round theme--light download-ticket"
          :disabled="!ticketDownloaded"
        >
          <span>{{ $t('getMyTicket') }}</span>
          <v-progress-circular
            v-show="!ticketDownloaded && !ticketError"
            color="primary"
            indeterminate
          />
        </a>
      </div>
      <button class="button-no-background" @click="goToPublicPage">
        {{ $t('backToEventPage') }}
      </button>
    </div>
  </div>
</template>

<script>
import { getEventSettings, getOrderInfoByUUID } from '../../http'
import ApplicationHeader from '../shared/application-header.vue'
import ApplicationFooter from '../shared/application-footer.vue'
import axios from 'axios'
import { GET_LOGGED_USER } from '../../graphql/user.graphql'
import { customerURL, landingURL } from '../../utils'
import i18next from 'i18next'

export default {
  name: 'successful-payment',
  components: {
    ApplicationHeader,
    ApplicationFooter,
  },
  data() {
    return {
      slug: undefined,
      ticketDownloaded: false,
      ticketError: false,
      customerURL,
      landingURL,
      user: null,
      order: null,
    }
  },
  async mounted() {
    const uuid = this.$router.history.current.params.orderUUID
    localStorage.removeItem('order')
    this.order = await getOrderInfoByUUID(uuid)
    const preferredLanguage = this.order.event.organization.preferredLanguage
    i18next.changeLanguage(preferredLanguage == 'en' ? 'en' : 'hr')
    this.downloadTicket(uuid)
    const { slug } = await getEventSettings(this.order.eventId)
    this.slug = slug
    const { data = {} } = await this.getUser()
    const { me: user } = data || {}
    this.user = user
  },
  methods: {
    goToPublicPage() {
      window.open(`${landingURL}/events/${this.slug}`, '_self')
    },
    async downloadTicket(uuid) {
      try {
        const { data: ticket } = await axios.get(
          `${process.env.VUE_APP_SERVER_URL}/files/tickets/${uuid}`,
        )
        const byteString = window.atob(ticket.body)
        const arrayBuffer = new ArrayBuffer(byteString.length)
        const int8Array = new Uint8Array(arrayBuffer)
        for (let i = 0; i < byteString.length; i++) {
          int8Array[i] = byteString.charCodeAt(i)
        }
        const blob = new Blob([int8Array], { type: 'application/pdf' })
        const url = URL.createObjectURL(blob)
        const downloadLink = document.getElementById('download-ticket')
        downloadLink.href = url
        downloadLink.setAttribute('download', 'CoreEvent-karte.pdf')
        this.ticketDownloaded = true
      } catch (e) {
        this.ticketError = true
      }
    },
    async getUser() {
      return this.$apollo.query({
        query: GET_LOGGED_USER,
      })
    },
  },
}
</script>

<style scoped>
.button-no-background {
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: -0.015em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
}

.mt-50 {
  margin-top: 50px;
}

.my-page-title {
  font-family: Raleway, serif;
  font-style: normal;
  font-weight: bold;
  text-align: center;
  font-size: 38px;
  line-height: 45px;
  color: #ff4c00;
  margin-bottom: 24px;
  margin-top: 60px;
}

.registration-success-page-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.registration-success-page {
  max-width: 40rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.info-image {
  width: 100%;
  height: 30rem;
}

.description {
  font-family: Source Sans Pro, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 23px;
  text-align: center;
  color: #333333;
}

.mt-220 {
  margin-top: 220px;
}

#buttons-container {
  margin: 2rem 0;
  max-width: 640px !important;
  display: flex;
}

@media screen and (max-width: 561px) {
  #buttons-container {
    flex-direction: column;
  }
}

.download-ticket {
  background-color: white;
  border: 2px solid #0277bd;
  color: #0277bd;
}

.v-btn--disabled {
  border: none;
}

#download-ticket .v-progress-circular {
  margin-left: 10px;
}

.main-button {
  font-size: 16px;
  height: 36px;
  font-family: Raleway, sans-serif;
  font-weight: bold;
  line-height: 1.5;
}
</style>
